import {
  Flex,
  Image,
  ListItem,
  SimpleGrid,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import type { IconsList } from 'types/cms/blocks';

export function IconsListSmall({ icons }: Pick<IconsList, 'icons'>) {
  const iconsAmount = icons?.length;

  return (
    <SimpleGrid
      as={UnorderedList}
      columns={{
        base: 1,
        md: iconsAmount,
      }}
      listStyleType="none"
      m={0}
      p={0}
      spacingY="2xs"
    >
      {icons.map((icon) => (
        <Flex
          as={ListItem}
          key={icon._key}
          px={{ md: '3xs' }}
          textAlign={{ base: 'left', md: 'center' }}
          alignItems="center"
          gap="3xs"
          flexDirection={{ base: 'row', md: 'column' }}
        >
          <Image
            boxSize="xs"
            objectFit="contain"
            mx={{ md: 'auto' }}
            src={icon.asset.url}
            alt=""
          />
          <Text size="overline">{icon.label}</Text>
        </Flex>
      ))}
    </SimpleGrid>
  );
}
